import { render, staticRenderFns } from "./empty-page-without-layout.vue?vue&type=template&id=56caf7a4&"
import script from "./empty-page-without-layout.ts?vue&type=script&lang=ts&"
export * from "./empty-page-without-layout.ts?vue&type=script&lang=ts&"
import style0 from "./empty-page-without-layout.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports